import { BrowserRouter, Route, Routes } from "react-router-dom";
import Rastaurant from "./page/Rastaurant";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Rastaurant />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
